import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';

export default WithApp(function ModalTypeWorker(props) {
  const worker = props.model;
  const customerPortfolioB = props.model;
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  return (
    <>
      <Modal
        title={`Nuevo tipo de trabajador`}
        model={{ open: worker.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/tipo-trabajadores'
      >
        <TextField
          label="Código"
          fullWidth
          type="text"
          name="code"
          margin="normal"
          value={dataChanging.code || ''}
          onChange={(e) => handleChange('code', e.target.value)}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          value={dataChanging.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
